module.exports = __webpack_public_path__ + "img/_attach_right.1779c2a5.svg";